import Reveal from "../Reveal";
import { ArrowUpRight } from "lucide-react";
import { useBooking } from "../../lib/booking";

export default function Services({ services }) {
  const { openBooking } = useBooking();
  if (!services?.length) return null;

  return (
    <section
      id="services"
      data-testid="services"
      style={{ padding: "7rem 0", background: "var(--fs-surface-alt)", borderTop: "1px solid var(--fs-line)" }}
    >
      <div className="fs-container">
        <div className="grid md:grid-cols-12 gap-10 mb-10 md:mb-14 items-end">
          <Reveal className="md:col-span-7">
            <p className="fs-overline" data-testid="services-overline">THE MENU · CH. 02</p>
            <h2 className="fs-display-2" style={{ marginTop: "1rem" }} data-testid="services-title">
              Five stylists.<br />
              <span className="fs-ital">One standard.</span>
            </h2>
          </Reveal>
          <Reveal className="md:col-span-5" delay={120}>
            <p style={{ color: "var(--fs-ink-soft)", fontSize: "1rem", lineHeight: 1.7, maxWidth: "440px" }}>
              Every chair is reserved — never rushed. Pricing starts here; final quotes are tailored
              to your hair, your mood, and the time you have.
            </p>
          </Reveal>
        </div>

        <Reveal>
          <div style={{ borderTop: "1px solid var(--fs-line-strong)", marginTop: "2rem" }}>
            {services.map((s) => (
              <button
                type="button"
                key={s.id}
                onClick={openBooking}
                className="fs-svc-row"
                style={{ width: "100%", background: "transparent", border: "none", borderBottom: "1px solid var(--fs-line)", textAlign: "left" }}
                data-testid={`service-row-${s.number}`}
              >
                <div className="flex items-baseline gap-4 md:gap-7" style={{ minWidth: 0 }}>
                  <span className="fs-overline" style={{ color: "var(--fs-muted)", fontWeight: 600 }}>
                    {s.number}
                  </span>
                  <div style={{ minWidth: 0 }}>
                    <div className="fs-svc-name">{s.name}</div>
                    {s.description && (
                      <div
                        style={{
                          marginTop: "0.5rem",
                          color: "var(--fs-muted)",
                          fontSize: "0.9rem",
                          lineHeight: 1.5,
                          maxWidth: "560px",
                        }}
                        className="hidden md:block"
                      >
                        {s.description}
                      </div>
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-3 md:gap-5 fs-svc-meta">
                  <span>from {s.price_from}</span>
                  <ArrowUpRight size={16} style={{ color: "var(--fs-caramel)" }} />
                </div>
              </button>
            ))}
          </div>
        </Reveal>

        <Reveal className="mt-12">
          <button
            type="button"
            onClick={openBooking}
            className="fs-btn-primary"
            data-testid="services-book-cta"
          >
            Reserve a Chair <ArrowUpRight size={14} />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
